import xlsxExport from '../../shared/xlsxExport/xlsxExport';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';
import columnDefinitions from '../../shared/columnDefinitions/legalEntities';
import { periodColumnDefinition } from '../../shared/columnDefinitions';
import { sortBySeverity } from '../../shared/sortBySeverity';

export default ({
  periodName,
  entities,
  hideDecimals,
  negativeMinus,
  shouldDisplayZero,
  environmentSuffix,
}) => {
  const legalEntitiesWithPeriods = entities.map(legalEntity => ({
    periodName,
    ...legalEntity,
  })).sort(sortBySeverity);

  const sheetData = [
    {
      name: 'Legal Entities',
      type: SheetExportTypes.GRID,
      descriptionColumnIndex: -1,
      columnDefinitions: [
        {
          ...periodColumnDefinition,
          rowGroup: true,
          hide: true,
          enableGroup: true,
          minWidth: 200,
        },
        ...columnDefinitions,
      ],
      data: legalEntitiesWithPeriods,
      options: {
        hideDecimals,
        negativeMinus,
        shouldDisplayZero,
      },
    },
    {
      name: 'Metadata',
      type: SheetExportTypes.CUSTOM,
      data: [],
      options: {
        addTimestamp: true,
      },
    },
  ];

  xlsxExport({
    sheetData,
    metadata: {
      fileName: `TLS_Legal_Entities_${periodName}${environmentSuffix}`,
      disableHeaderRendering: true,
    },
  });
};
